const isLocalhost = location.hostname === 'localhost'
const isProduction = !location.hostname.startsWith('test.') && !isLocalhost
export default isProduction
